import type { MapControls } from "three/examples/jsm/controls/MapControls.js"
import type { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js"
import getSetEngineWeakMapFactory from "./getSetEngineWeakMapFactory"

type EngineThreeControls = MapControls | OrbitControls

export const [getEngineThreeControls, setEngineThreeControls] = getSetEngineWeakMapFactory<EngineThreeControls>()
